import { object, string } from "yup";
import { IAccountSettings } from "./types";

export const getAccountSettingsSchema = () => object({
    first_name: string().label("First Name").max(50).required("First name is required"),
    last_name: string().label("Last Name").max(50).required("Last name is required"),
    email: string().label("Email").email("Must be a valid email").max(80).required("Email is required"),
    phone_number: string().label("Phone Number").max(20).required("Phone number is required"),
    account_type: string().label("Account Type").required(),
    old_password: string()
        .label("Old Password")
        .notRequired(),
    new_password: string()
        .label("New Password")
        .test('min-length-if-provided', 'New password must be at least 8 characters', function (value) {
            const { old_password } = this.parent;
            // Only validate if old password is provided (user wants to change password)
            if (old_password && old_password.trim() !== '') {
                if (value && value.trim() !== '') {
                    return value.length >= 8;
                }
                return false; // New password required if old password provided
            }
            return true; // Valid if no old password provided
        })
        .test('passwords-different', 'New password must be different from old password', function (value) {
            const { old_password } = this.parent;
            if (old_password && old_password.trim() !== '' && value && value.trim() !== '') {
                return old_password !== value;
            }
            return true;
        })
        .notRequired(),
    // Company fields are optional and read-only
    company__company_name: string().notRequired(),
    company__parent_company_name: string().notRequired(),
    company__dba_name: string().notRequired(),
    company__address1: string().notRequired(),
    company__address2: string().notRequired(),
    company__city: string().notRequired(),
    company__state: string().notRequired(),
    company__postal_code: string().notRequired(),
    company__urbanization: string().notRequired(),
    company__federal_tax_id: string().notRequired(),
    company__naics_code: string().notRequired(),
    company__usps_mailer_id: string().notRequired(),
    company__company_registration_id: string().notRequired(),
    company__phone: string().notRequired(),
    company__company_website: string().notRequired(),
});

export const getDefaultFormValues = (): IAccountSettings => ({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    account_type: "",
    old_password: "",
    new_password: "",
    company__company_name: "",
    company__parent_company_name: "",
    company__dba_name: "",
    company__address1: "",
    company__address2: "",
    company__city: "",
    company__state: "",
    company__postal_code: "",
    company__urbanization: "",
    company__federal_tax_id: "",
    company__naics_code: "",
    company__usps_mailer_id: "",
    company__company_registration_id: "",
    company__phone: "",
    company__company_website: "",
});
